export enum RunEnv {
  LOCAL,
  DEV,
  TEST,
  PROD,
}

const isLocalhost = () => {
  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  );
};

const isDev = () => {
  return (
    window.location.hostname === 'https://mdportal-dev.hitiqapp.com/' ||
    window.location.hostname === 'https://conneqt-dev-us.hitiqapp.com/'
  );
};

const isTest = () => {
  return window.location.hostname === 'https://conneqt-test.hitiqapp.com/';
};

interface FeatureProps {
  runEnvs: RunEnv[];
  enabled: boolean;
}

const featureFlags: Record<string, FeatureProps> = {
  languageSwitcher: { runEnvs: [RunEnv.LOCAL], enabled: true },
  experimentalFeature: { runEnvs: [RunEnv.TEST], enabled: false },
};

export const featureFlag = (featureName: string): boolean => {
  const feature: FeatureProps = featureFlags[featureName];

  if (feature && feature.enabled) {
    if (feature.runEnvs.includes(RunEnv.LOCAL)) {
      return isLocalhost();
    }
    if (feature.runEnvs.includes(RunEnv.DEV)) {
      return isDev();
    }
    if (feature.runEnvs.includes(RunEnv.TEST)) {
      return isTest();
    }
  }

  return false;
};
